import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { Subscription } from 'rxjs';
import { Theme } from 'src/app/models/theme';
import { ProfileService } from 'src/app/api/profile.service';
import { ThemeService } from 'src/app/services/theme.service';
import { ChatService } from 'src/app/services/chat.service';

@Component({
  selector: 'vip-page',
  templateUrl: './vip-page.component.html',
  styleUrls: ['./vip-page.component.scss'],
})
export class VipPageComponent implements OnInit, OnDestroy {
  readonly VIP_ADDRESS = 'vip@bitoasis.net';

  @ViewChild('joinVIP') joinVIP: ElementRef;

  vip = false;
  queryParamsChangeSubscription: Subscription;
  isMobileWebView = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private profileService: ProfileService,
    private themeService: ThemeService,
    private chatService: ChatService,
  ) {}

  ngOnInit() {
    this._handleQueryParamsChange();
    this.themeService.set(Theme.Dark);
    this.getProfile();
  }

  ngOnDestroy() {
    this.themeService.remove();
    this.queryParamsChangeSubscription?.unsubscribe();
  }

  private _handleQueryParamsChange() {
    this.queryParamsChangeSubscription = this.route.queryParamMap.subscribe(params => {
      this.isMobileWebView = params.get('mobile') === 'true';
      if (this.isMobileWebView) {
        this.chatService.destroy();
      }
    });
  }

  joinVip(anchor = false) {
    if (anchor) {
      return this.joinVIP.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    this.router.navigate(['/support/otc']);
  }

  getProfile() {
    this.profileService.getGeneral().subscribe(response => {
      this.vip = response?.vip;
    });
  }
}
